
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play-preview/[domain]/about-us",
      function () {
        return require("private-next-pages/play-preview/[domain]/about-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play-preview/[domain]/about-us"])
      });
    }
  